
import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IPersonHypermediaRepresentation } from '../../shared/contracts/PersonContract';
import { urlService } from '../../shared/services/UrlService';
import { IUserState } from '../../store/contract';
import store from '../../store/store';
const userNamespace = 'user';

@Component({})
export default class Settings extends Vue {
    public person: IPersonHypermediaRepresentation | {} = {};

    @State(userNamespace)
    private userState: IUserState;

    async created() {
        const url = urlService.replaceURIPlaceholders(store.state.root._links.person.href, {
            personId: this.userState.user.id.toString()
        });
        const person = await axios.request<IPersonHypermediaRepresentation>({
            url,
            method: store.state.root._links.person.method
        });
        this.person = person.data;
    }

    public async setReminderTo() {
        const user = this.userState;
        const person = this.person as IPersonHypermediaRepresentation;
        if (person.sendReminder) {
            await axios.request({
                url: person._actions.setReminder.href,
                method: person._actions.setReminder.method
            });
        } else {
            await axios.request({
                url: person._actions.unsetReminder.href,
                method: person._actions.unsetReminder.method
            });
        }
    }
}
